import { FormWordGroup } from '../../models/ComboFormState';
import { chain } from 'lodash';
import { useCallback } from 'react';
import { SetFormState } from '../../models/SetFormState';

export function useRemoveGroup(setFormState: SetFormState, removeId: string) {
  return useCallback(
    () =>
      setFormState((prevState) => {
        // Perform delete operation
        const wordGroups = chain(prevState.wordGroups)
          .filter((wg) => wg.id !== removeId)
          .orderBy([(wg: FormWordGroup) => wg.order], ['asc'])
          .map((wg, index) => ({ ...wg, order: index }))
          .value();

        const comboCombinations = chain(prevState.comboCombinations)
          .filter((wgC) => !wgC.wordGroups.some((wgId) => wgId.id === removeId))
          .value();

        return {
          ...prevState,
          wordGroups,
          comboCombinations,
        };
      }),
    [setFormState, removeId]
  );
}
